document.addEventListener('DOMContentLoaded', function () {
  // ---- Mobile menu ----
  var menu = document.querySelector('.js-mobile-menu');
  var openBtn = document.querySelector('.js-mobile-menu-open');
  var closeBtn = document.querySelector('.js-mobile-menu-close');
  if (menu && openBtn) {
    openBtn.addEventListener('click', function () {
      menu.classList.remove('hidden');
      menu.classList.add('flex');
      document.body.style.overflow = 'hidden';
    });
  }
  if (menu && closeBtn) {
    closeBtn.addEventListener('click', function () {
      menu.classList.add('hidden');
      menu.classList.remove('flex');
      document.body.style.overflow = '';
    });
  }

  // ---- Search toggle ----
  var searchToggle = document.querySelector('.js-search-toggle');
  var searchPanel = document.querySelector('.js-search-panel');
  if (searchToggle && searchPanel) {
    searchToggle.addEventListener('click', function () {
      searchPanel.classList.toggle('hidden');
      var input = searchPanel.querySelector('input[name="q"]');
      if (input && !searchPanel.classList.contains('hidden')) input.focus();
    });
  }

  // ---- Category scroll active state ----
  document.querySelectorAll('.js-category-pill').forEach(function (pill) {
    pill.addEventListener('click', function (e) {
      document.querySelectorAll('.js-category-pill').forEach(function (p) {
        p.classList.remove('bg-primary', 'text-white', 'shadow-md', 'shadow-primary/30', 'scale-105');
        p.classList.add('bg-secondary', 'text-foreground');
      });
      pill.classList.remove('bg-secondary', 'text-foreground');
      pill.classList.add('bg-primary', 'text-white', 'shadow-md', 'shadow-primary/30', 'scale-105');
    });
  });

  // ---- Shop by budget tabs ----
  var budgetTabs = document.querySelectorAll('.js-budget-tab');
  var budgetItems = document.querySelectorAll('.js-budget-item');
  function applyBudgetFilter(maxPrice) {
    budgetItems.forEach(function (item) {
      var price = parseFloat(item.getAttribute('data-price'));
      item.style.display = price <= maxPrice ? '' : 'none';
    });
  }
  budgetTabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      budgetTabs.forEach(function (t) {
        t.classList.remove('bg-primary', 'text-white', 'shadow-lg', 'shadow-primary/30', 'scale-105');
        t.classList.add('bg-card', 'border', 'border-border', 'text-foreground');
      });
      tab.classList.remove('bg-card', 'border', 'border-border', 'text-foreground');
      tab.classList.add('bg-primary', 'text-white', 'shadow-lg', 'shadow-primary/30', 'scale-105');
      applyBudgetFilter(parseFloat(tab.getAttribute('data-max-price')));
    });
  });
  if (budgetTabs.length) applyBudgetFilter(parseFloat(budgetTabs[0].getAttribute('data-max-price')));

  // ---- Wishlist persistence (localStorage) ----
  var WISHLIST_KEY = 'curiozone_wishlist';
  function getWishlist() {
    try { return JSON.parse(localStorage.getItem(WISHLIST_KEY)) || []; } catch (e) { return []; }
  }
  function setWishlist(ids) {
    localStorage.setItem(WISHLIST_KEY, JSON.stringify(ids));
  }
  var wishlist = getWishlist();
  document.querySelectorAll('.js-wishlist-btn').forEach(function (btn) {
    var id = btn.getAttribute('data-product-id');
    if (wishlist.indexOf(id) > -1) {
      btn.classList.add('is-wishlisted');
      var icon = btn.querySelector('svg');
      if (icon) { icon.classList.add('fill-primary', 'text-primary'); icon.classList.remove('text-muted-foreground'); }
    }
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var current = getWishlist();
      var idx = current.indexOf(id);
      var icon = btn.querySelector('svg');
      if (idx > -1) {
        current.splice(idx, 1);
        btn.classList.remove('is-wishlisted');
        if (icon) { icon.classList.remove('fill-primary', 'text-primary'); icon.classList.add('text-muted-foreground'); }
      } else {
        current.push(id);
        btn.classList.add('is-wishlisted');
        if (icon) { icon.classList.add('fill-primary', 'text-primary'); icon.classList.remove('text-muted-foreground'); }
      }
      setWishlist(current);
    });
  });

  // ---- Product page: option selection + variant switching ----
  var variantsJsonEl = document.getElementById('ProductVariantsJson');
  if (variantsJsonEl) {
    var variants = JSON.parse(variantsJsonEl.textContent);
    var variantIdInput = document.getElementById('ProductVariantId');
    var priceEl = document.getElementById('ProductPrice');
    var addBtn = document.getElementById('AddToCartButton');
    var addText = document.getElementById('AddToCartText');
    var selected = {};

    document.querySelectorAll('.js-option-value').forEach(function (btn) {
      var idx = btn.getAttribute('data-option-index');
      if (btn.classList.contains('bg-primary')) selected[idx] = btn.getAttribute('data-value');
    });

    function updateVariant() {
      var match = variants.find(function (v) {
        return Object.keys(selected).every(function (idx) {
          return v.options[parseInt(idx, 10)] === selected[idx];
        });
      });
      if (!match) return;
      variantIdInput.value = match.id;
      if (priceEl) priceEl.textContent = formatMoney(match.price);
      if (addBtn) {
        addBtn.disabled = !match.available;
        if (addText) addText.textContent = match.available ? 'Add to Cart' : 'Sold Out';
      }
      var img = document.getElementById('ProductMainImage');
      if (img && match.featured_image) img.src = match.featured_image.src;
    }

    function formatMoney(cents) {
      return (window.Shopify && Shopify.formatMoney)
        ? Shopify.formatMoney(cents, window.moneyFormat || '₹{{amount}}')
        : '₹' + (cents / 100).toFixed(2);
    }

    document.querySelectorAll('.js-option-value').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var idx = btn.getAttribute('data-option-index');
        document.querySelectorAll('.js-option-value[data-option-index="' + idx + '"]').forEach(function (b) {
          b.classList.remove('bg-primary', 'text-white', 'border-primary');
        });
        btn.classList.add('bg-primary', 'text-white', 'border-primary');
        selected[idx] = btn.getAttribute('data-value');
        updateVariant();
      });
    });

    document.querySelectorAll('.js-thumb').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var img = document.getElementById('ProductMainImage');
        if (img) img.src = thumb.getAttribute('data-full');
      });
    });
  }

  // ---- Quick add-to-cart from product cards ----
  document.querySelectorAll('.js-quick-add').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var variantId = btn.getAttribute('data-variant-id');
      if (!variantId) return;
      btn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      })
        .then(function (res) { return res.json(); })
        .then(function () { return fetch('/cart.js'); })
        .then(function (res) { return res.json(); })
        .then(function (cart) { updateCartBubble(cart.item_count); })
        .catch(function (err) { console.error('CurioZone: add to cart failed', err); })
        .finally(function () { btn.disabled = false; });
    });
  });

  function updateCartBubble(count) {
    var bubble = document.querySelector('.cart-count-bubble');
    if (bubble) {
      bubble.textContent = count;
    } else if (count > 0) {
      var cartLink = document.querySelector('a[href="' + (window.routes ? window.routes.cart_url : '/cart') + '"]');
      if (cartLink) {
        var span = document.createElement('span');
        span.className = 'cart-count-bubble absolute -top-0.5 -right-0.5 w-4 h-4 bg-primary text-white text-[9px] font-black rounded-full flex items-center justify-center';
        span.textContent = count;
        cartLink.appendChild(span);
      }
    }
  }
});
